import { stateClasses } from '../utils/classes';
import { classesAsStr } from './Multiselect';
import RemovableTag, { RemovableTagProps } from '../RemovableTag';
import { GroupBase, MultiValueProps } from 'react-select';
import { ReactElement } from 'react';

const CustomMultiValue = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: MultiValueProps<Option, IsMulti, Group>
): ReactElement => {
  const { data, isFocused, isDisabled, removeProps, selectProps } = props;

  const handleOnRemove: RemovableTagProps['onRemove'] = (event): void => {
    if (removeProps.onClick) {
      // Type assertion is unfortunate, but MouseEvent for HTMLDivElement and HTMLButtonElement
      // are probably close enough to not matter too much.
      removeProps.onClick(event as unknown as React.MouseEvent<HTMLDivElement, MouseEvent>);
    }
  };

  const classes = `${stateClasses({ focused: isFocused })} ${classesAsStr({ element: 'multivalue' })}`;

  return (
    <RemovableTag
      className={classes}
      text={selectProps.getOptionLabel(data)}
      onRemove={handleOnRemove}
      tabIndex={-1}
      disabled={isDisabled}
      onMouseDown={(event) => {
        /*
          in order to prevent focusing the parent select when removing a tag
          stop the mouse down event from bubbling when it comes from the close button
          */
        const closeButton = event.currentTarget.querySelector('.fe_c_removable-tag__remove');
        if (closeButton?.contains(event.target as Node)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }}
    />
  );
};

export default CustomMultiValue;
